import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import AdminLayout from "../components/AdminLayout";
import { IconPlus, IconTrash } from "@tabler/icons-react";

function VisitasNovo() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    // Ocorrência
    tipo_ocorrencia: "",
    endereco_ocorrencia: "",
    bairro_ocorrencia: "",
    zona_ocorrencia: "",
    
    // Identificação do Responsável
    responsavel_cpf: "",
    responsavel_rg: "",
    responsavel_nome: "",
    responsavel_data_nascimento: "",
    resposavel_filiacao: {},
    responsavel_nacionalidade: "",
    responsavel_naturalidade: "",
    responsavel_uf: "",
    responsavel_orientacao_sexual: "",
    responsavel_raca: "",
    responsavel_estado_civil: "",
    responsavel_renda: "",
    responsavel_ocupacao: "",
    
    // Escolaridade
    responsavel_escolaridade: "",
    
    // Endereço / Contato
    resposavel_tempo_no_endereco: "",
    responsavel_endereco: "",
    responsavel_bairro: "",
    responsavel_telefone: "",
    
    // Composição Familiar
    responsavel_membros_familiar: "",
    composicao_familiar: [], // Array para guardar os membros da família
    
    // Benefícios
    beneficio_recebe: false,
    beneficios: {  // Adicionando objeto beneficios ao estado inicial
      bolsa_familia: false,
      bpc: false,
      auxilio_brasil: false,
      auxilio_emergencial: false,
      seguro_desemprego: false,
      peti: false,
      outros: false,
      outros_descricao: ''
    },
    
    // Pedido
    pedido_responsavel: "",
    pedido_descricao_necessidade: "",
    urgencia: "",
    data_visita: "",
    hora_visita: "",
    pedido_status: "",
    observacao: "",
    itens_atendidos: [],
    
    // Habitação
    habitacao_situacao: "",
    habitacao_comodos: "",
    habitacao_valor_aluguel: "",
    habitacao_tipo_construcao: "",
    habitacao_programa: "",
    habitacao_programa_processo: "",
    
    // Aspectos Sociais
    aspectos_sociais: {},
    
    // Encaminhamentos
    encaminhamento: "",
    
    // Auxílio Aluguel
    auxilio_aluguel: false,
    auxilio_aluguel_tempo_concedido: "",
    auxilio_aluguel_tempo_concedido_inicio: "",
    auxilio_aluguel_tempo_concedido_fim: "",
    
    // Relato Social
    relato_social: "",
    
    // Responsável pelo Atendimento
    responsavel_tecnico_atendimento: ""
    
    // Removido a duplicação de composicao_familiar
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
  
    let formattedValue = value;
    
    // Verificar se é um campo do tipo checkbox
    if (type === 'checkbox') {
      setFormData({
        ...formData,
        [name]: checked
      });
      return;
    }
    
    // Formatação para campos específicos
    if (name === "responsavel_cpf") {
      formattedValue = formatCPF(value);
    }
    if (name === "responsavel_renda" || name === "habitacao_valor_aluguel") {
      formattedValue = formatValor(value);
    }
    if (name === "responsavel_telefone") {
      formattedValue = formatTelefone(value);
    }
    if (name === "responsavel_data_nascimento" || name === "data_visita" || 
        name === "auxilio_aluguel_tempo_concedido_inicio" || name === "auxilio_aluguel_tempo_concedido_fim") {
      formattedValue = formatData(value);
    }
    if (name === "hora_visita") {
      formattedValue = formatHora(value);
    }
    
    setFormData({
      ...formData,
      [name]: formattedValue,
    });
  };

  const formatTelefone = (value) => {
    value = value.replace(/\D/g, "");
    value = value.slice(0, 11);

    if (value.length <= 10) {
      return value
        .replace(/^(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{4})(\d)/, "$1-$2");
    } else {
      return value
        .replace(/^(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{5})(\d)/, "$1-$2");
    }
  };

  // Formats a date input (assumed digits only) into DD/MM/YYYY as the user types
  const formatData = (value) => {
    // Remove non-digit characters and limit to 8 digits (DDMMYYYY)
    const digits = value.replace(/\D/g, "").substring(0, 8);
    let formatted = digits;
    if (digits.length >= 3) {
      formatted = digits.substring(0, 2) + "/" + digits.substring(2, 4);
    }
    if (digits.length >= 5) {
      formatted += "/" + digits.substring(4, 8);
    }
    return formatted;
  };

  // Formats a time input (assumed digits only) into HH:MM:SS as the user types
  const formatHora = (value) => {
    // Remove non-digit characters and limit to 6 digits (HHMMSS)
    const digits = value.replace(/\D/g, "").substring(0, 6);
    let formatted = digits;
    if (digits.length >= 3) {
      formatted = digits.substring(0, 2) + ":" + digits.substring(2, 4);
    }
    return formatted;
  };

  const formatValor = (value) => {
    value = value.replace(/\D/g, "");
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value / 100);
  };

  // Formats a CPF number into the mask 000.000.000-00
  const formatCPF = (value) => {
    // Remove non-digits and limit to 11 digits
    const digits = value.replace(/\D/g, "").substring(0, 11);
    let formatted = digits;
    if (digits.length > 3) {
      formatted = digits.substring(0, 3) + "." + digits.substring(3);
    }
    if (digits.length > 6) {
      // After inserting the first dot, the second dot should be inserted at position 7
      formatted = formatted.substring(0, 7) + "." + formatted.substring(7);
    }
    if (digits.length > 9) {
      // After dots, the dash is inserted at position 11
      formatted = formatted.substring(0, 11) + "-" + formatted.substring(11);
    }
    return formatted;
  };
  
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);  // Define como enviando

    // Prepara os dados para envio
    const formDataToSend = {
      ...formData,
      responsavel_telefone: formData.responsavel_telefone.replace(/[^\d]/g, ""), // Remove formatação do telefone
      responsavel_cpf: formData.responsavel_cpf.replace(/[^\d]/g, ""), // Remove formatação do CPF
      responsavel_renda: formData.responsavel_renda ? parseFloat(formData.responsavel_renda.replace(/[^\d,]/g, "").replace(",", ".")) : null,
      habitacao_valor_aluguel: formData.habitacao_valor_aluguel ? parseFloat(formData.habitacao_valor_aluguel.replace(/[^\d,]/g, "").replace(",", ".")) : null,
      responsavel_membros_familiar: formData.responsavel_membros_familiar ? parseInt(formData.responsavel_membros_familiar) : null,
      composicao_familiar: formData.composicao_familiar.map(membro => ({
        ...membro,
        cpf: membro.cpf ? membro.cpf.replace(/[^\d]/g, "") : "",
        renda: membro.renda ? parseFloat(membro.renda.replace(/[^\d,]/g, "").replace(",", ".")) : null,
        data_nascimento: membro.data_nascimento ? formatarDataParaAPI(membro.data_nascimento) : null
      }))
    };

    // Converte datas para o formato aceito pelo Django (YYYY-MM-DD)
    if (formData.responsavel_data_nascimento) {
      const parts = formData.responsavel_data_nascimento.split('/');
      if (parts.length === 3) {
        formDataToSend.responsavel_data_nascimento = `${parts[2]}-${parts[1]}-${parts[0]}`;
      }
    }

    if (formData.data_visita) {
      const parts = formData.data_visita.split('/');
      if (parts.length === 3) {
        formDataToSend.data_visita = `${parts[2]}-${parts[1]}-${parts[0]}`;
      }
    }

    if (formData.auxilio_aluguel_tempo_concedido_inicio) {
      const parts = formData.auxilio_aluguel_tempo_concedido_inicio.split('/');
      if (parts.length === 3) {
        formDataToSend.auxilio_aluguel_tempo_concedido_inicio = `${parts[2]}-${parts[1]}-${parts[0]}`;
      }
    }

    if (formData.auxilio_aluguel_tempo_concedido_fim) {
      const parts = formData.auxilio_aluguel_tempo_concedido_fim.split('/');
      if (parts.length === 3) {
        formDataToSend.auxilio_aluguel_tempo_concedido_fim = `${parts[2]}-${parts[1]}-${parts[0]}`;
      }
    }

    try {
      const response = await fetch(`${API_BASE_URL}visitas/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formDataToSend),
      });

      if (response.ok) {
        setSuccessMessage("Visita cadastrada com sucesso!");
        // Reset do formulário - corrigindo para composicao_familiar ser um array vazio
        setFormData({
          tipo_ocorrencia: "",
          endereco_ocorrencia: "",
          bairro_ocorrencia: "",
          zona_ocorrencia: "",
          responsavel_cpf: "",
          responsavel_rg: "",
          responsavel_nome: "",
          responsavel_data_nascimento: "",
          resposavel_filiacao: {},
          responsavel_nacionalidade: "",
          responsavel_naturalidade: "",
          responsavel_uf: "",
          responsavel_orientacao_sexual: "",
          responsavel_raca: "",
          responsavel_estado_civil: "",
          responsavel_renda: "",
          responsavel_ocupacao: "",
          responsavel_escolaridade: "",
          resposavel_tempo_no_endereco: "",
          responsavel_endereco: "",
          responsavel_bairro: "",
          responsavel_telefone: "",
          responsavel_membros_familiar: "",
          beneficio_recebe: false,
          beneficios: {
            bolsa_familia: false,
            bpc: false,
            auxilio_brasil: false,
            auxilio_emergencial: false,
            seguro_desemprego: false,
            peti: false,
            outros: false,
            outros_descricao: ''
          },
          pedido_responsavel: "",
          pedido_descricao_necessidade: "",
          urgencia: "",
          data_visita: "",
          hora_visita: "",
          pedido_status: "",
          observacao: "",
          itens_atendidos: 0,
          habitacao_situacao: "",
          habitacao_comodos: "",
          habitacao_valor_aluguel: "",
          habitacao_tipo_construcao: "",
          habitacao_programa: "",
          habitacao_programa_processo: "",
          aspectos_sociais: {},
          encaminhamento: "",
          auxilio_aluguel: false,
          auxilio_aluguel_tempo_concedido: "",
          auxilio_aluguel_tempo_concedido_inicio: "",
          auxilio_aluguel_tempo_concedido_fim: "",
          relato_social: "",
          responsavel_tecnico_atendimento: "",
          composicao_familiar: [] // Corrigido para array vazio
        });
        
        setTimeout(() => {
          setSuccessMessage("");  // Oculta a mensagem de sucesso após alguns segundos
          navigate("/visitas");  // Redireciona para a página de listagem
        }, 3000);
      } else {
        setErrorMessage("Falha ao cadastrar visita.");
      }
    } catch (error) {
      setErrorMessage("Ocorreu um erro ao enviar o formulário.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleBeneficioChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    setFormData({
      ...formData,
      beneficios: {
        ...formData.beneficios,
        [name]: type === 'checkbox' ? checked : value
      }
    });
  };

  // Corrigindo a função handleMembroChange para receber três parâmetros
  const handleMembroChange = (e, index, campo) => {
    const { value } = e.target;
    
    // Formatações específicas para certos campos
    let valorFormatado = value;
    
    if (campo === 'cpf') {
      valorFormatado = formatCPF(value);
    } else if (campo === 'data_nascimento') {
      valorFormatado = formatData(value);
    } else if (campo === 'renda') {
      valorFormatado = formatValor(value);
    }
    
    const novaComposicao = [...formData.composicao_familiar];
    novaComposicao[index][campo] = valorFormatado;
    
    setFormData({
      ...formData,
      composicao_familiar: novaComposicao
    });
  };

  // Função para adicionar um novo membro em branco à lista
  const handleAddMembro = () => {
    setFormData({
      ...formData,
      composicao_familiar: [
        ...formData.composicao_familiar,
        {
          nome: '',
          parentesco: '',
          data_nascimento: '',
          cpf: '',
          escolaridade: '',
          ocupacao: '',
          renda: ''
        }
      ]
    });
  };

  // Função para remover um membro da lista
  const handleRemoveMembro = (index) => {
    const novaComposicao = [...formData.composicao_familiar];
    novaComposicao.splice(index, 1);
    
    setFormData({
      ...formData,
      composicao_familiar: novaComposicao
    });
  };

  //Itens atendidos
  // Função para adicionar um novo item à lista
  const handleAddItem = () => {
    setFormData(prev => ({
      ...prev,
      itens_atendidos: [...prev.itens_atendidos, { quantidade: 1, item: '' }]
    }));
  };

  // Função para atualizar um item existente
  const handleItemChange = (e, index, field) => {
    const updatedItems = [...formData.itens_atendidos];
    updatedItems[index][field] = field === 'quantidade' ? parseInt(e.target.value, 10) : e.target.value;
    
    setFormData(prev => ({
      ...prev,
      itens_atendidos: updatedItems
    }));
  };

  // Opcionalmente, você pode adicionar uma função para remover um item
  const handleRemoveItem = (index) => {
    const updatedItems = [...formData.itens_atendidos];
    updatedItems.splice(index, 1);
    
    setFormData(prev => ({
      ...prev,
      itens_atendidos: updatedItems
    }));
  };

  // Função auxiliar para converter as datas
  const formatarDataParaAPI = (dataStr) => {
    if (!dataStr) return null;
    const partes = dataStr.split('/');
    if (partes.length !== 3) return null;
    return `${partes[2]}-${partes[1]}-${partes[0]}`;
  };

  useEffect(() => {
    if (successMessage || errorMessage) {
      const timer = setTimeout(() => {
        setSuccessMessage("");
        setErrorMessage("");
      }, 5000); // 5 segundos
      return () => clearTimeout(timer);
    }
  }, [successMessage, errorMessage]);

  return (
    <AdminLayout>
      <div>
        {successMessage && (
          <div className="alert alert-success alert-float">
            {successMessage}
          </div>
        )}
        {errorMessage && (
          <div className="alert alert-danger alert-float">
            {errorMessage}
          </div>
        )}
      </div>
      <div className="container mt-4">
        <div className="col-12">
          <form className="card" onSubmit={handleSubmit}>
            <div className="card-body">
              <h3 className="card-title">Cadastro de Visita</h3>
              <div className="row row-cards">
                {/* Dados da Ocorrência */}
                <h4 className="mt-4">1. Dados da Ocorrência</h4>
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">Tipo de Ocorrência</label>
                    <input type="text" className="form-control" name="tipo_ocorrencia" onChange={handleChange} value={formData.tipo_ocorrencia} />
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="mb-3">
                    <label className="form-label">Endereço da Ocorrência</label>
                    <input type="text" className="form-control" name="endereco_ocorrencia" onChange={handleChange} value={formData.endereco_ocorrencia} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Bairro da Ocorrência</label>
                    <input type="text" className="form-control" name="bairro_ocorrencia" onChange={handleChange} value={formData.bairro_ocorrencia} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Zona da Ocorrência</label>
                    <input type="text" className="form-control" name="zona_ocorrencia" onChange={handleChange} value={formData.zona_ocorrencia} />
                  </div>
                </div>

                {/* Identificação do Responsável */}
                <h4 className="mt-4">2. Identificação do Responsável</h4>
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label">CPF</label>
                    <input type="text" className="form-control" name="responsavel_cpf" onChange={handleChange} value={formData.responsavel_cpf} />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label">RG</label>
                    <input type="text" className="form-control" name="responsavel_rg" onChange={handleChange} value={formData.responsavel_rg} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Nome Completo</label>
                    <input type="text" className="form-control" name="responsavel_nome" onChange={handleChange} value={formData.responsavel_nome} />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label">Data de Nascimento</label>
                    <input type="text" className="form-control" name="responsavel_data_nascimento" onChange={handleChange} value={formData.responsavel_data_nascimento} />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label">Nacionalidade</label>
                    <input type="text" className="form-control" name="responsavel_nacionalidade" onChange={handleChange} value={formData.responsavel_nacionalidade} />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label">Naturalidade</label>
                    <input type="text" className="form-control" name="responsavel_naturalidade" onChange={handleChange} value={formData.responsavel_naturalidade} />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label">UF</label>
                    <select className="form-select" name="responsavel_uf" onChange={handleChange} value={formData.responsavel_uf}>
                      <option value="">Selecione...</option>
                      <option value="AC">Acre (AC)</option>
                      <option value="AL">Alagoas (AL)</option>
                      <option value="AP">Amapá (AP)</option>
                      <option value="AM">Amazonas (AM)</option>
                      <option value="BA">Bahia (BA)</option>
                      <option value="CE">Ceará (CE)</option>
                      <option value="DF">Distrito Federal (DF)</option>
                      <option value="ES">Espírito Santo (ES)</option>
                      <option value="GO">Goiás (GO)</option>
                      <option value="MA">Maranhão (MA)</option>
                      <option value="MT">Mato Grosso (MT)</option>
                      <option value="MS">Mato Grosso do Sul (MS)</option>
                      <option value="MG">Minas Gerais (MG)</option>
                      <option value="PA">Pará (PA)</option>
                      <option value="PB">Paraíba (PB)</option>
                      <option value="PR">Paraná (PR)</option>
                      <option value="PE">Pernambuco (PE)</option>
                      <option value="PI">Piauí (PI)</option>
                      <option value="RJ">Rio de Janeiro (RJ)</option>
                      <option value="RN">Rio Grande do Norte (RN)</option>
                      <option value="RS">Rio Grande do Sul (RS)</option>
                      <option value="RO">Rondônia (RO)</option>
                      <option value="RR">Roraima (RR)</option>
                      <option value="SC">Santa Catarina (SC)</option>
                      <option value="SP">São Paulo (SP)</option>
                      <option value="SE">Sergipe (SE)</option>
                      <option value="TO">Tocantins (TO)</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label">Orientação Sexual</label>
                    <select className="form-select" name="responsavel_orientacao_sexual" onChange={handleChange} value={formData.responsavel_orientacao_sexual}>
                      <option value="">Selecione...</option>
                      <option value="heterossexual">Heterossexual</option>
                      <option value="homossexual">Homossexual</option>
                      <option value="bissexual">Bissexual</option>
                      <option value="outro">Outro</option>
                      <option value="nao-informado">Não Informado</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label">Raça/Cor</label>
                    <select className="form-select" name="responsavel_raca" onChange={handleChange} value={formData.responsavel_raca}>
                      <option value="">Selecione...</option>
                      <option value="branca">Branca</option>
                      <option value="preta">Preta</option>
                      <option value="parda">Parda</option>
                      <option value="amarela">Amarela</option>
                      <option value="indigena">Indígena</option>
                      <option value="nao-informado">Não Informado</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label">Estado Civil</label>
                    <select className="form-select" name="responsavel_estado_civil" onChange={handleChange} value={formData.responsavel_estado_civil}>
                      <option value="">Selecione...</option>
                      <option value="solteiro">Solteiro(a)</option>
                      <option value="casado">Casado(a)</option>
                      <option value="divorciado">Divorciado(a)</option>
                      <option value="separado">Separado(a)</option>
                      <option value="viuvo">Viúvo(a)</option>
                      <option value="uniao_estavel">União Estável</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label">Renda Mensal</label>
                    <input type="text" className="form-control" name="responsavel_renda" onChange={handleChange} value={formData.responsavel_renda} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Ocupação / Profissão</label>
                    <input type="text" className="form-control" name="responsavel_ocupacao" onChange={handleChange} value={formData.responsavel_ocupacao} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Escolaridade</label>
                    <select className="form-select" name="responsavel_escolaridade" onChange={handleChange} value={formData.responsavel_escolaridade}>
                      <option value="">Selecione...</option>
                      <option value="sem-escolaridade">Sem Escolaridade</option>
                      <option value="fundamental-incompleto">Fundamental Incompleto</option>
                      <option value="fundamental-completo">Fundamental Completo</option>
                      <option value="medio-incompleto">Médio Incompleto</option>
                      <option value="medio-completo">Médio Completo</option>
                      <option value="superior-incompleto">Superior Incompleto</option>
                      <option value="superior-completo">Superior Completo</option>
                      <option value="pos-graduacao">Pós-graduação</option>
                    </select>
                  </div>
                </div>

                {/* Identificação Endereço / Contato */}
                <h4 className="mt-4">3. Endereço e Contato</h4>
                <div className="col-md-2">
                  <div className="mb-3">
                    <label className="form-label">Tempo no Endereço</label>
                    <input type="text" className="form-control" name="resposavel_tempo_no_endereco" onChange={handleChange} value={formData.resposavel_tempo_no_endereco} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Endereço</label>
                    <input type="text" className="form-control" name="responsavel_endereco" onChange={handleChange} value={formData.responsavel_endereco} />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">Bairro</label>
                    <input type="text" className="form-control" name="responsavel_bairro" onChange={handleChange} value={formData.responsavel_bairro} />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">Telefone</label>
                    <input type="text" className="form-control" name="responsavel_telefone" onChange={handleChange} value={formData.responsavel_telefone} />
                  </div>
                </div>

                {/* Composição Familiar */}
                <h4 className="mt-4">4. Composição Familiar</h4>
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label className="form-label">Número de Membros</label>
                        <input 
                          type="number" 
                          className="form-control" 
                          name="responsavel_membros_familiar" 
                          onChange={handleChange} 
                          value={formData.responsavel_membros_familiar} 
                          min="0"
                        />
                      </div>
                    </div>
                  </div>
                  
                  {formData.responsavel_membros_familiar && parseInt(formData.responsavel_membros_familiar) > 0 && (
                    <div>
                      <h4 className="mt-4">Composição Familiar</h4>
                      <div className="table-responsive mt-4">
                        <table className="table mb-0">
                          <thead>
                            <tr>
                              <th>Nome</th>
                              <th>Parentesco</th>
                              <th>Data Nasc.</th>
                              <th>CPF</th>
                              <th>Escolaridade</th>
                              <th>Ocupação</th>
                              <th>Renda</th>
                              <th>Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            {formData.composicao_familiar.map((membro, index) => (
                              <tr key={index}>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={membro.nome}
                                    onChange={(e) => handleMembroChange(e, index, 'nome')}
                                  />
                                </td>
                                <td>
                                  <select
                                    className="form-select"
                                    value={membro.parentesco}
                                    onChange={(e) => handleMembroChange(e, index, 'parentesco')}
                                  >
                                    <option value="">Selecione...</option>
                                    <option value="cônjuge">Cônjuge</option>
                                    <option value="filho(a)">Filho(a)</option>
                                    <option value="pai">Pai</option>
                                    <option value="mãe">Mãe</option>
                                    <option value="irmão/irmã">Irmão/Irmã</option>
                                    <option value="avô/avó">Avô/Avó</option>
                                    <option value="neto(a)">Neto(a)</option>
                                    <option value="sobrinho(a)">Sobrinho(a)</option>
                                    <option value="outro">Outro</option>
                                  </select>
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={membro.data_nascimento}
                                    onChange={(e) => handleMembroChange(e, index, 'data_nascimento')}
                                    placeholder="DD/MM/AAAA"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={membro.cpf}
                                    onChange={(e) => handleMembroChange(e, index, 'cpf')}
                                    placeholder="000.000.000-00"
                                  />
                                </td>
                                <td>
                                  <select
                                    className="form-select"
                                    value={membro.escolaridade}
                                    onChange={(e) => handleMembroChange(e, index, 'escolaridade')}
                                  >
                                    <option value="">Selecione...</option>
                                    <option value="sem-escolaridade">Sem Escolaridade</option>
                                    <option value="fundamental-incompleto">Fundamental Incompleto</option>
                                    <option value="fundamental-completo">Fundamental Completo</option>
                                    <option value="medio-incompleto">Médio Incompleto</option>
                                    <option value="medio-completo">Médio Completo</option>
                                    <option value="superior-incompleto">Superior Incompleto</option>
                                    <option value="superior-completo">Superior Completo</option>
                                    <option value="pos-graduacao">Pós-graduação</option>
                                  </select>
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={membro.ocupacao}
                                    onChange={(e) => handleMembroChange(e, index, 'ocupacao')}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={membro.renda}
                                    onChange={(e) => handleMembroChange(e, index, 'renda')}
                                    placeholder="R$ 0,00"
                                  />
                                </td>
                                <td>
                                  <button 
                                    type="button" 
                                    className="btn btn-danger btn-sm"
                                    onClick={() => handleRemoveMembro(index)}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      
                      {/* Botão para adicionar novo membro */}
                      {formData.composicao_familiar.length < parseInt(formData.responsavel_membros_familiar) && (
                        <button 
                          type="button" 
                          className="btn btn-teal mt-2" 
                          onClick={handleAddMembro}
                        >
                          <IconPlus size={20} />
                        </button>
                      )}
                      
                      {/* Mensagem informativa sobre o progresso */}
                      <div className="mt-2 text-muted">
                        <small>
                          {formData.composicao_familiar.length} de {formData.responsavel_membros_familiar} membros adicionados
                        </small>
                      </div>
                    </div>
                  )}
                </div>
                <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">Recebe Benefício?</label>
                  <div className="form-check form-switch">
                    <input 
                      className="form-check-input" 
                      type="checkbox" 
                      name="beneficio_recebe" 
                      checked={formData.beneficio_recebe} 
                      onChange={handleChange} 
                    />
                    <label className="form-check-label">{formData.beneficio_recebe ? "Sim" : "Não"}</label>
                  </div>
                </div>
                
                {formData.beneficio_recebe && (
                  <div className="card mt-2 mb-3">
                    <div className="card-header">
                      <h6 className="mb-0">Selecione os benefícios recebidos</h6>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-check mb-2">
                            <input 
                              className="form-check-input" 
                              type="checkbox" 
                              id="bolsa_familia" 
                              name="bolsa_familia"
                              checked={formData.beneficios?.bolsa_familia || false}
                              onChange={handleBeneficioChange}
                            />
                            <label className="form-check-label" htmlFor="bolsa_familia">
                              Bolsa Família
                            </label>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-check mb-2">
                            <input 
                              className="form-check-input" 
                              type="checkbox" 
                              id="bpc" 
                              name="bpc"
                              checked={formData.beneficios?.bpc || false}
                              onChange={handleBeneficioChange}
                            />
                            <label className="form-check-label" htmlFor="bpc">
                              BPC (Benefício de Prestação Continuada)
                            </label>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-check mb-2">
                            <input 
                              className="form-check-input" 
                              type="checkbox" 
                              id="auxilio_brasil" 
                              name="auxilio_brasil"
                              checked={formData.beneficios?.auxilio_brasil || false}
                              onChange={handleBeneficioChange}
                            />
                            <label className="form-check-label" htmlFor="auxilio_brasil">
                              Auxílio Brasil
                            </label>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-check mb-2">
                            <input 
                              className="form-check-input" 
                              type="checkbox" 
                              id="auxilio_emergencial" 
                              name="auxilio_emergencial"
                              checked={formData.beneficios?.auxilio_emergencial || false}
                              onChange={handleBeneficioChange}
                            />
                            <label className="form-check-label" htmlFor="auxilio_emergencial">
                              Auxílio Emergencial
                            </label>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-check mb-2">
                            <input 
                              className="form-check-input" 
                              type="checkbox" 
                              id="seguro_desemprego" 
                              name="seguro_desemprego"
                              checked={formData.beneficios?.seguro_desemprego || false}
                              onChange={handleBeneficioChange}
                            />
                            <label className="form-check-label" htmlFor="seguro_desemprego">
                              Seguro Desemprego
                            </label>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-check mb-2">
                            <input 
                              className="form-check-input" 
                              type="checkbox" 
                              id="peti" 
                              name="peti"
                              checked={formData.beneficios?.peti || false}
                              onChange={handleBeneficioChange}
                            />
                            <label className="form-check-label" htmlFor="peti">
                              PETI (Programa de Erradicação do Trabalho Infantil)
                            </label>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-check mb-2">
                            <input 
                              className="form-check-input" 
                              type="checkbox" 
                              id="outros" 
                              name="outros"
                              checked={formData.beneficios?.outros || false}
                              onChange={handleBeneficioChange}
                            />
                            <label className="form-check-label" htmlFor="outros">
                              Outros Benefícios
                            </label>
                          </div>
                        </div>
                        
                        {formData.beneficios?.outros && (
                          <div className="col-md-12 mt-2">
                            <div className="form-floating">
                              <textarea 
                                className="form-control" 
                                id="outros_descricao" 
                                name="outros_descricao"
                                value={formData.beneficios?.outros_descricao || ''}
                                onChange={handleBeneficioChange}
                                style={{ height: '80px' }}
                              ></textarea>
                              <label htmlFor="outros_descricao">Descreva os outros benefícios</label>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>

                {/* Infraestrutura da Habitação */}
                <h4 className="mt-4">5. Infraestrutura da Habitação</h4>
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label">Situação Habitacional</label>
                    <select className="form-select" name="habitacao_situacao" onChange={handleChange} value={formData.habitacao_situacao}>
                      <option value="">Selecione...</option>
                      <option value="propria">Própria</option>
                      <option value="alugada">Alugada</option>
                      <option value="cedida">Cedida</option>
                      <option value="invasao">Invasão</option>
                      <option value="financiada">Financiada</option>
                      <option value="ocupacao">Ocupação</option>
                      <option value="situacao_rua">Situação de Rua</option>
                      <option value="outro">Outro</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label">Número de Cômodos</label>
                    <input type="number" className="form-control" name="habitacao_comodos" onChange={handleChange} value={formData.habitacao_comodos} />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label">Valor do Aluguel</label>
                    <input type="text" className="form-control" name="habitacao_valor_aluguel" onChange={handleChange} value={formData.habitacao_valor_aluguel} />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label">Tipo de Construção</label>
                    <select className="form-select" name="habitacao_tipo_construcao" onChange={handleChange} value={formData.habitacao_tipo_construcao}>
                      <option value="">Selecione...</option>
                      <option value="alvenaria">Alvenaria</option>
                      <option value="madeira">Madeira</option>
                      <option value="mista">Mista</option>
                      <option value="outros">Outros</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Programa de Habitação</label>
                    <input type="text" className="form-control" name="habitacao_programa" onChange={handleChange} value={formData.habitacao_programa} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Nº Protocolo do Processo</label>
                    <input type="text" className="form-control" name="habitacao_programa_processo" onChange={handleChange} value={formData.habitacao_programa_processo} />
                  </div>
                </div>

                {/* Auxilio Aluguel */}
                <h4 className="mt-4">6. Auxílio Aluguel</h4>
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label">Possui Auxílio Aluguel?</label>
                    <div className="form-check form-switch mt-2">
                      <input 
                        className="form-check-input" 
                        type="checkbox" 
                        name="auxilio_aluguel" 
                        checked={formData.auxilio_aluguel} 
                        onChange={handleChange} 
                      />
                      <label className="form-check-label">{formData.auxilio_aluguel ? "Sim" : "Não"}</label>
                    </div>
                  </div>
                </div>

                {formData.auxilio_aluguel && (
                  <>
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label className="form-label">Tempo Concedido</label>
                        <input type="text" className="form-control" name="auxilio_aluguel_tempo_concedido" onChange={handleChange} value={formData.auxilio_aluguel_tempo_concedido} />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label className="form-label">Data de Início</label>
                        <input type="text" className="form-control" name="auxilio_aluguel_tempo_concedido_inicio" onChange={handleChange} value={formData.auxilio_aluguel_tempo_concedido_inicio} />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label className="form-label">Data de Término</label>
                        <input type="text" className="form-control" name="auxilio_aluguel_tempo_concedido_fim" onChange={handleChange} value={formData.auxilio_aluguel_tempo_concedido_fim} />
                      </div>
                    </div>
                  </>
                )}

                {/* Detalhes do Pedido */}
                <h4 className="mt-4">7. Detalhes do Pedido</h4>
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">Tipo de Solicitação</label>
                    <input type="text" className="form-control" name="pedido_responsavel" onChange={handleChange} value={formData.pedido_responsavel} />
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="mb-3">
                    <label className="form-label">Descrição da Necessidade</label>
                    <textarea className="form-control" name="pedido_descricao_necessidade" rows="3" onChange={handleChange} value={formData.pedido_descricao_necessidade}></textarea>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">Grau de Urgência</label>
                    <select className="form-select" name="urgencia" onChange={handleChange} value={formData.urgencia}>
                      <option value="">Selecione...</option>
                      <option value="baixa">Baixa</option>
                      <option value="media">Média</option>
                      <option value="alta">Alta</option>
                      <option value="critica">Crítica</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">Data de Atendimento</label>
                    <input type="text" className="form-control" name="data_visita" onChange={handleChange} value={formData.data_visita} />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">Hora da Visita</label>
                    <input type="text" className="form-control" name="hora_visita" onChange={handleChange} value={formData.hora_visita} />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">Status do Pedido</label>
                    <select className="form-select" name="pedido_status" onChange={handleChange} value={formData.pedido_status}>
                      <option value="">Selecione...</option>
                      <option value="pendente">Pendente</option>
                      <option value="em_analise">Em Análise</option>
                      <option value="aprovado">Aprovado</option>
                      <option value="recusado">Recusado</option>
                      <option value="concluido">Concluído</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-4">
                <div className="mb-3">
                  <label className="form-label">Itens Atendidos</label>
                  <div className="table-responsive mt-2">
                    <table className="table mb-0">
                      <thead>
                        <tr>
                          <th>Quantidade</th>
                          <th>Item</th>
                          <th>Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formData.itens_atendidos && formData.itens_atendidos.length > 0 ? (
                          formData.itens_atendidos.map((item, index) => (
                            <tr key={index}>
                              <td>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={item.quantidade}
                                  onChange={(e) => handleItemChange(e, index, 'quantidade')}
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={item.item}
                                  onChange={(e) => handleItemChange(e, index, 'item')}
                                />
                              </td>
                              <td>
                                <button 
                                  type="button" 
                                  className="btn btn-danger btn-sm"
                                  onClick={() => handleRemoveItem(index)}
                                >
                                  <IconTrash size={16} />
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="3" className="text-center">Nenhum item adicionado</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <button type="button" className="btn btn-teal mt-2" onClick={handleAddItem}>
                    <IconPlus size={20} />
                  </button>
                </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Observação</label>
                    <textarea className="form-control" name="observacao" rows="3" onChange={handleChange} value={formData.observacao}></textarea>
                  </div>
                </div>

                {/* Aspectos Sociais */}
                <h4 className="mt-4">8. Aspectos Sociais</h4>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Aspectos Sociais Observados</label>
                    <div className="card">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-check mb-2">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="violencia_domestica"
                                checked={formData.aspectos_sociais?.violencia_domestica || false}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    aspectos_sociais: {
                                      ...formData.aspectos_sociais,
                                      violencia_domestica: e.target.checked
                                    }
                                  });
                                }}
                              />
                              <label className="form-check-label" htmlFor="violencia_domestica">
                                Violência Doméstica
                              </label>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-check mb-2">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="dependencia_quimica"
                                checked={formData.aspectos_sociais?.dependencia_quimica || false}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    aspectos_sociais: {
                                      ...formData.aspectos_sociais,
                                      dependencia_quimica: e.target.checked
                                    }
                                  });
                                }}
                              />
                              <label className="form-check-label" htmlFor="dependencia_quimica">
                                Dependência Química
                              </label>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-check mb-2">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="desemprego"
                                checked={formData.aspectos_sociais?.desemprego || false}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    aspectos_sociais: {
                                      ...formData.aspectos_sociais,
                                      desemprego: e.target.checked
                                    }
                                  });
                                }}
                              />
                              <label className="form-check-label" htmlFor="desemprego">
                                Desemprego
                              </label>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-check mb-2">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="pessoa_deficiencia"
                                checked={formData.aspectos_sociais?.pessoa_deficiencia || false}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    aspectos_sociais: {
                                      ...formData.aspectos_sociais,
                                      pessoa_deficiencia: e.target.checked
                                    }
                                  });
                                }}
                              />
                              <label className="form-check-label" htmlFor="pessoa_deficiencia">
                                Pessoa com Deficiência
                              </label>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-check mb-2">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="pessoa_idosa"
                                checked={formData.aspectos_sociais?.pessoa_idosa || false}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    aspectos_sociais: {
                                      ...formData.aspectos_sociais,
                                      pessoa_idosa: e.target.checked
                                    }
                                  });
                                }}
                              />
                              <label className="form-check-label" htmlFor="pessoa_idosa">
                                Pessoa Idosa
                              </label>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-check mb-2">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="baixa_renda"
                                checked={formData.aspectos_sociais?.baixa_renda || false}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    aspectos_sociais: {
                                      ...formData.aspectos_sociais,
                                      baixa_renda: e.target.checked
                                    }
                                  });
                                }}
                              />
                              <label className="form-check-label" htmlFor="baixa_renda">
                                Baixa Renda
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Encaminhamentos */}
                <h4 className="mt-4">9. Encaminhamentos</h4>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Encaminhamentos</label>
                    <input type="text" className="form-control" name="encaminhamento" onChange={handleChange} value={formData.encaminhamento} />
                  </div>
                </div>

                {/* Relato Social */}
                <h4 className="mt-4">10. Relato Social</h4>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Relato Social</label>
                    <textarea className="form-control" name="relato_social" rows="5" onChange={handleChange} value={formData.relato_social}></textarea>
                  </div>
                </div>

                {/* Responsável pelo Atendimento */}
                <h4 className="mt-4">11. Responsável pelo Atendimento</h4>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Responsável Técnico</label>
                    <input type="text" className="form-control" name="responsavel_tecnico_atendimento" onChange={handleChange} value={formData.responsavel_tecnico_atendimento} />
                  </div>
                </div>
              </div>
            </div>
            {/* Botões de Ação */}
            <div className="card-footer text-end">
                  <button type="button" className="btn btn-secondary me-2" onClick={() => navigate('/visitas')}>
                    Cancelar
                  </button>
                  <button type="submit" disabled={isSubmitting} className="btn btn-primary">
                    {isSubmitting ? 'Salvando...' : 'Salvar'}
                  </button>
                </div>
          </form>
        </div>
      </div>
    </AdminLayout>
  );
}

export default VisitasNovo;